<template>
  <div class="page-content">
    <!-- MIGAS -->
    <nav class="page-breadcrumb" id="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{ breadcrumbA }}</li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ breadcrumbB }}
        </li>
      </ol>
    </nav>
    <!-- FORMULARIO DE FILTRO -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">{{ breadcrumbB }}</h6>
            <p class="card-description">{{ descripcion }}</p>
            <h6 class="card-title mt-4">
              Seleccioná las fechas y planta a consultar
            </h6>
            <div class="row">
              <!-- selección de rango -->
              <div class="col-8">
                <form>
                  <div class="row mb-3">
                    <div class="col">
                      <label for="desdeasist">Desde</label>
                      <input
                        type="date"
                        id="desdeasist"
                        class="form-control"
                        v-model="fdesde"
                        @change="chequearRangoFecha"
                      />
                      <span
                        class="text-danger"
                        v-if="!fdesde"
                      >· La fecha de inicio es obligatoria</span>
                    </div>
                    <div class="col">
                      <label for="hastaasist">Hasta</label>
                      <input
                        type="date"
                        id="hastaasist"
                        class="form-control"
                        v-model="fhasta"
                        @change="chequearRangoFecha"
                      />
                    </div>
                    <div class="col-12" v-if="alert.tiempo">
                      <div class="alert alert-warning">{{ alert.tiempo }}</div>
                    </div>
                  </div>
                  <label for="zona">Zona seleccionada</label>
                  <select
                    id="zona"
                    class="custom-select"
                    v-model="zonaSeleccionada"
                  >
                    <option
                      v-for="z in zonas"
                      :key="z.codigo"
                      :value="z.codigo"
                    >
                      {{ z.nombre }}
                    </option>
                  </select>
                  <div class="text-right mt-3">
                    <button
                      class="btn btn-success"
                      @click.prevent="consulta"
                    >
                      Consultar presentes
                    </button>
                  </div>
                </form>
              </div>
              <!-- resumen rápido -->
              <div class="col-4">
                <div class="border border-light rounded p-3 h-100">
                  <h6 class="my-2 text-uppercase">Vista rápida</h6>
                  <p v-if="fdesde && fhasta && fdesde !== fhasta">
                    Desde el día
                    <span class="badge badge-light">{{ fdesde }}</span> hasta el
                    <span class="badge badge-light">{{ fhasta }}</span>
                  </p>
                  <p v-else-if="fdesde === fhasta">
                    Del día <span class="badge badge-light">{{ fdesde }}</span>
                  </p>
                  <p v-else>Ninguna fecha seleccionada</p>
                  <hr />
                  <div>
                    <div class="row mb-1">
                      <div class="col-9">Dentro de convenio</div>
                      <div class="col-3 text-right">
                        <span class="badge badge-light">{{ convenio1 }}</span>
                      </div>
                    </div>
                    <div class="row mb-1">
                      <div class="col-9">Fuera de convenio</div>
                      <div class="col-3 text-right">
                        <span class="badge badge-light">{{ conveniono1 }}</span>
                      </div>
                    </div>
                    <div class="row mb-1">
                      <div class="col-9">Total</div>
                      <div class="col-3 text-right">
                        <span class="badge badge-light">{{ total1 }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /resumen -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- error rango -->
    <div class="row" v-if="errors.fdesdeInvalida">
      <div class="col">
        <div class="alert alert-danger">
          La fecha de inicio es obligatoria. Ingresala para poder buscar.
        </div>
      </div>
    </div>
    <!-- TABLA -->
    <lista-carga v-if="load" />
    <div class="row" v-else>
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table id="asistencias_b" class="table">
                <thead>
                  <tr>
                    <th>Legajo</th>
                    <th>Nombre</th>
                    <th>Categoria</th>
                    <th>Sector</th>
                    <th>Fecha Entrada</th>
                    <th>Fecha Salida</th>
                    <th>Hora Entrada</th>
                    <th>Hora Salida</th>
                    <th>Total Horas</th>
                    <th v-if="isLector('VerHorario')">Ingreso&nbsp;Status</th>
                    <th v-if="isLector('VerHorario')">Carga&nbsp;Horaria</th>
                    <th>Convenio</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(v, k) in asistencias" :key="k">
                    <td>{{ v.legajo }}</td>
                    <td>{{ v.nombre }}</td>
                    <td>{{ v.categoria }}</td>
                    <td>{{ v.sector }}</td>
                    <td>{{ v.fechaEntrada }}</td>
                    <td>{{ v.fechaSalida }}</td>
                    <td>
                      {{ v.horaEntrada }}
                      <span v-if="v.fotoEntrada">
                        <a @click="abrirImagenBase64(v.fotoEntrada)">
                          <img src="assets/view.png" class="vista" />
                        </a>
                      </span>
                    </td>
                    <td>
                      {{ v.horaSalida }}
                      <span v-if="v.fotoSalida">
                        <a @click="abrirImagenBase64(v.fotoSalida)">
                          <img src="assets/view.png" class="vista" />
                        </a>
                      </span>
                    </td>
                    <td>{{ v.total }}</td>
                    <td v-if="isLector('VerHorario')">
                      <span v-if="v.ingresoStatus=='-'">-</span>
                      <span
                        v-else-if="v.ingresoStatus=='En horario'"
                        class="badge badge-success"
                      >
                        En horario
                      </span>
                      <span
                        v-else-if="v.ingresoStatus=='Tolerancia'"
                        class="badge badge-warning"
                      >
                        Tolerancia
                      </span>
                      <span
                        v-else-if="v.ingresoStatus=='Tarde'"
                        class="badge badge-danger"
                      >
                        Tarde
                      </span>
                    </td>
                    <td v-if="isLector('VerHorario')">
                      <span v-if="v.cargaHoraria=='-'">-</span>
                      <span
                        v-else-if="v.cargaHoraria=='Cumplió'"
                        class="badge badge-success"
                      >
                        Cumplió
                      </span>
                      <span
                        v-else-if="v.cargaHoraria=='No cumplió'"
                        class="badge badge-danger"
                      >
                        No cumplió
                      </span>
                    </td>
                    <td>{{ v.convenio }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import moment from "moment";
import "moment/locale/es";
require("datatables.net");
require("datatables.net-buttons/js/buttons.colVis.js")();
require("datatables.net-buttons/js/buttons.html5.js")();
require("datatables.net-buttons/js/buttons.flash.js")();
require("datatables.net-buttons/js/buttons.print.js")();
import ListaCarga from "../ListaCarga";
import config from "./config";
import DTConfig from "@/dataTableConfig.js";
moment.locale("es");

const FIREBASE_BASE = "https://aplicativos.firebaseio.com";
const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));

export default {
  name: "Presentismo",
  components: { ListaCarga },
  data: () => ({
    breadcrumbA: "Inicio",
    breadcrumbB: "Presentismo",
    descripcion:
      "Podés seleccionar una fecha específica y una planta para visualizar la lista del personal activo.",
    fdesde: null,
    fhasta: null,
    total1: 0,
    conveniono1: 0,
    convenio1: 0,
    zonas: [],
    asistencias: [],
    load: true,
    zonaSeleccionada: null,
    alert: { tiempo: "" },
    errors: { fdesdeInvalida: false },
  }),
  methods: {
    isLector(modulo){
      if (userPermission && userPermission.find(record => record.ModulosAccess === modulo)) {
        return userPermission.find(record => record.ModulosAccess === modulo).Lector;
      } else {
        return false;
      }
    },
    pad(n, w) {
      return n.toString().padStart(w, "0");
    },
    reemplazarIndefinido(s) {
      return s ? s : "-";
    },
    normalizarCodigoZona(codigo) {
      return String(codigo || "").trim();
    },
    getCodigosZona(zona) {
      if (!zona) return [];
      if (Array.isArray(zona.codigos)) {
        return zona.codigos.map(this.normalizarCodigoZona);
      }
      return [this.normalizarCodigoZona(zona.codigo)];
    },
    zonaCoincide(zonaRegistro) {
      const zona = this.zonas.find(z => z.codigo === this.zonaSeleccionada);
      return this.getCodigosZona(zona).includes(this.normalizarCodigoZona(zonaRegistro));
    },
    fechaActual() {
      return moment().format("YYYY-MM-DD");
    },
    abrirImagenBase64(src) {
      const w = 300, h = 300;
      const left = screen.width / 2 - w / 2;
      const top = screen.height / 2 - h / 2;
      const win = window.open("", `img${Date.now()}`, `width=${w},height=${h},left=${left},top=${top}`);
      win.document.write(
        `<html><body style="margin:0"><img style="width:100%;height:100%" src="${src}"/></body></html>`
      );
      win.document.close();
    },
    chequearRangoFecha() {
      this.alert.tiempo = "";
      this.errors.fdesdeInvalida = !this.fdesde;
      if (!this.fdesde) return;
      const mesD = +this.fdesde.split("-")[1];
      const mesH = this.fhasta ? +this.fhasta.split("-")[1] : mesD;
      const diff = mesH - mesD;
      if (diff > 0 && diff <= 2)
        this.alert.tiempo = "La consulta puede demorar algunos segundos…";
      else if (diff > 2)
        this.alert.tiempo = "La consulta puede demorar más de 10 s…";
    },
    consulta() {
      if (!this.fdesde) {
        this.errors.fdesdeInvalida = true;
        return;
      }
      if (!this.fhasta) this.fhasta = this.fechaActual();
      this.load = true;
      const url = `https://auth.foodservice.com.ar/?type=presentismo&desde=${this.fdesde}&hasta=${this.fhasta}&access_token=1234567`;
      axios
        .all([axios.get(url), axios.get(`${FIREBASE_BASE}/horarios.json`)])
        .then(
          axios.spread((respPres, respHor) => {
            const presentes = respPres.data;
            const horariosDB = respHor.data || {};
            this.convenio1 = 0;
            this.conveniono1 = 0;
            this.asistencias = presentes.flatMap(p => {
              if (!this.zonaCoincide(p.zona)) return [];
              const dia = moment(p.fechaEntrada).format('dddd');
              const planDia = (horariosDB[p.legajo]?.horarios || [])
                .find(h => h.dia.toLowerCase() === dia.toLowerCase() && h.trabaja) || {};

              // --- cálculo del total trabajado ---
              let total = "-";
              if (p.fechaSalida) {
                const diff = moment.duration(
                  moment(`${p.fechaSalida} ${p.horaSalida}`).diff(
                    moment(`${p.fechaEntrada} ${p.horaEntrada}`)
                  )
                ).asSeconds();
                const h = Math.floor(diff / 3600);
                const m = Math.floor((diff % 3600) / 60);
                const s = diff % 60;
                total = `${this.pad(h,2)}:${this.pad(m,2)}:${this.pad(s,2)}`;
              }

              // --- ingresoStatus con tolerancia ---
              let ingresoStatus = "-";
              if (planDia.entrada && p.horaEntrada) {
                const plan = moment(planDia.entrada, "HH:mm");
                const real = moment(p.horaEntrada, "HH:mm:ss");
                const diffMin = real.diff(plan, 'minutes');
                if (diffMin <= 0) {
                  ingresoStatus = "En horario";
                } else if (diffMin <= 15) {
                  ingresoStatus = "Tolerancia";
                } else {
                  ingresoStatus = "Tarde";
                }
              }

              // --- carga horaria (minutos reales vs planificados) ---
              let cargaHoraria = "-";
              if (p.fechaSalida && planDia.entrada && planDia.salida) {
                const fmtFechaHora = "YYYY-MM-DD HH:mm:ss";
                const fmtHora      = "HH:mm";
                const realEntrada = moment(`${p.fechaEntrada} ${p.horaEntrada}`, fmtFechaHora);
                const realSalida  = moment(`${p.fechaSalida} ${p.horaSalida}`, fmtFechaHora);
                const minutosTrabajados = realSalida.diff(realEntrada, 'minutes');
                const planEntrada = moment(planDia.entrada, fmtHora);
                const planSalida  = moment(planDia.salida, fmtHora);
                const minutosPlanificados = planSalida.diff(planEntrada, 'minutes');
                cargaHoraria = minutosTrabajados >= minutosPlanificados
                  ? "Cumplió"
                  : "No cumplió";
              }

              // --- contadores convenio ---
              p.convenio === "FUERA DE CONVENIO"
                ? this.conveniono1++
                : this.convenio1++;

              return {
                legajo: p.legajo,
                nombre: p.nombre,
                categoria: p.categoria,
                sector: this.reemplazarIndefinido(p.sector),
                fechaEntrada: p.fechaEntrada,
                fechaSalida: p.fechaSalida || "-",
                horaEntrada: p.horaEntrada,
                horaSalida: p.horaSalida || "-",
                total,
                ingresoStatus,
                cargaHoraria,
                convenio: p.convenio,
                fotoEntrada: p.fotoEntrada,
                fotoSalida: p.fotoSalida,
              };
            });
            this.total1 = this.convenio1 + this.conveniono1;
            this.load = false;

            this.$nextTick(() => {
              if ($.fn.DataTable.isDataTable('#asistencias_b')) {
                $('#asistencias_b').DataTable().destroy();
              }
              const tableConfig = {
                language: {
                  decimal: ",",
                  thousands: ".",
                  info:        "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                  infoEmpty:   "Mostrando registros del 0 al 0 de un total de 0 registros",
                  loadingRecords: "Cargando…",
                  lengthMenu: "Mostrar _MENU_ registros",
                  paginate: {
                    first: "Primero",
                    last: "Último",
                    next: "Siguiente",
                    previous: "Anterior"
                  },
                  processing: "Procesando…",
                  search: "Buscar:",
                  searchPlaceholder: "Término de búsqueda",
                  zeroRecords: "No se encontraron resultados",
                  emptyTable:"No se registraron presentes en el rango y planta seleccionados",
                  aria: {
                    sortAscending:  ": Activar para ordenar la columna de manera ascendente",
                    sortDescending: ": Activar para ordenar la columna de manera descendente"
                  }
                },
                scrollX: false,
                search: { regex: true },
                dom: "Bfrtip",
                buttons: ["copy", "excel", "csv", "pdf", "print"],
                responsive: true,
                nowrap: false
              };
              $("#asistencias_b").DataTable(tableConfig);
            });
          })
        )
        .catch(err => {
          console.error(err);
          alert(
            "Ocurrió un error al consultar. Recargá la página o contactate con Sistemas."
          );
          this.load = false;
        });
    },
  },
  mounted() {
    this.fdesde = this.fechaActual();
    this.fhasta = this.fdesde;
    this.zonas = config.zonas;
    this.zonaSeleccionada = this.zonas[0]?.codigo || null;
    this.consulta();
  },
};
</script>

<style scoped>
.form-control {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 0.8rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-select {
  font-size: 0.8rem;
}
.vista {
  width: 20px;
  height: 17px;
}
</style>